import {combineReducers} from "redux";
import video, {VideoStore, SubtitlesStore, subtitle} from "../common/video/VideoReducer";
import search, {SearchStore} from "../viewer/search/SearchReducer";
import presenters, {
    PresentersStore
} from "../viewer/presenters/PresentersReducer";
import user, {UserStore} from "../user/UserReducer";
import recommendList, {
    RecommendListStore
} from "../common/homePage/HomePageReducer";
import header, {HeaderStore} from "./components/layout/header/HeaderReducer";
import videoFilter, {
    VideoFilterStore
} from "../common/video/VideoFilterReducer";
import userFilter, {
    UserFilterStore
} from "../viewer/presenters/UserFilterReducer";
import exProject, {ExProjectStore} from "../store/reducers/ExProjectReducer";
import exVideo, {ExVideoStore} from "../store/reducers/ExVideoReducer";
import Survey, {SurveyStore} from "../store/reducers/SurveyReducer";

export interface AppState {
  video: VideoStore;
  search: SearchStore;
  presenters: PresentersStore;
  user: UserStore;
  header: HeaderStore;
  recommendList: RecommendListStore;
  videoFilter: VideoFilterStore;
  userFilter: UserFilterStore;
  exProject: ExProjectStore;
  exVideo: ExVideoStore;
  Survey: SurveyStore;
  subtitle: SubtitlesStore;
}

const rootReducer = combineReducers({
    video,
    search,
    presenters,
    user,
    header,
    recommendList,
    videoFilter,
    userFilter,
    exProject,
    exVideo,
    Survey,
    subtitle
});

export default rootReducer;
